/* unplugin-vue-components disabled */import { render } from "./KilaKilaPostArticleCard.vue?vue&type=template&id=5b52bc02&scoped=true"
import script from "./KilaKilaPostArticleCard.vue?vue&type=script&lang=js"
export * from "./KilaKilaPostArticleCard.vue?vue&type=script&lang=js"

import "./KilaKilaPostArticleCard.vue?vue&type=style&index=0&id=5b52bc02&scoped=true&lang=css"

import exportComponent from "/Users/zhaoxu/Documents/development.localized/public.localized/github/KilaKila-Blog/kilakila-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b52bc02"]])

export default __exports__